import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AlertService, MenuService, OperacionesTipoService, UsuariosService } from '@app/_services';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-operacionesTipo',
  templateUrl: './operacionesTipo.component.html'
})
export class OperacionesTipoComponent implements OnInit {

  form: FormGroup;
  dataOperacionesTipo: any;
  mySelection: number[] = [];
  navigationSubscription;
  isDeleting = false;

  modalReference: NgbModalRef;
  user = this.userService.userValue;

  constructor(private operacionesTipoService: OperacionesTipoService,
    private alertService: AlertService,
    private menuService: MenuService,
    public router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private userService: UsuariosService,
    private translateService: TranslateService,
    private modalService: NgbModal) {

    this.menuService.titulo = this.translateService.instant('operacionestipo').toUpperCase();

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      // If it is a NavigationEnd event re-initalise the component
      if (e instanceof NavigationEnd) {
        if (this.router.url == '/operacionestipo') {
          this.cargarDatos();
        }
      }
    });

  }

  cargarDatos() {
    this.operacionesTipoService.getAll().pipe(first()).subscribe((result) => {
      this.dataOperacionesTipo = result;
    });

  }

  ngOnInit(): void {
    this.cargarDatos();
  }

  cellClick(e) {
    if (e.columnIndex > 0) {
      this.router.navigate(['operacionestipo/editar/', this.mySelection[0]]);
    }
  }

  onClickEditar() {
    if (this.mySelection[0] > 0) {
      this.router.navigate(['operacionestipo/editar/', this.mySelection[0]]);
    }
  }

  onClickNuevo() {
    this.router.navigate(['operacionestipo/crear']);
  }

  onClickEliminar(content) {
    if (this.mySelection[0] > 0) {
      this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
    }
  }

  eliminarRegistro() {

    this.mySelection.forEach(element => {
      if (element > 0) {
        this.isDeleting = true;
        this.form = this.formBuilder.group({
          id: element
        });
        this.operacionesTipoService.delete(this.form.value.id).pipe(first()).subscribe({
          next: () => {
            this.dataOperacionesTipo = this.dataOperacionesTipo.filter(x => x.id !== element);
            this.isDeleting = false;
            this.alertService.success(this.translateService.instant('eliminadocorrectamente'), { keepAfterRouteChange: true });
            this.router.navigate(['../operacionestipo'], { relativeTo: this.route });
          },
          error: error => {
            this.isDeleting = false;
            this.alertService.error(error);
          }
        });
      }
    });

    this.modalReference.close();
    this.mySelection = [];

  }

}
